var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: {
      id: "picture-cropper-modal",
      "modal-dialog-size": "lg",
      "loaders-disabled": "",
    },
    on: { show: _vm.handleModalShown, hidden: _vm.handleModalHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("settings.accountTab.cropPicture")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "11" } },
                  [
                    _c("vue-cropper", {
                      ref: "cropper",
                      attrs: {
                        "wheel-zoom-ratio": 0.2,
                        "aspect-ratio": 1,
                        "view-mode": 1,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "1" } },
                  [
                    _c("picture-cropper-toolbar", {
                      on: { click: _vm.handleToolbarAction },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.handleSavePicture },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.crop")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }